export const styledBreakpoints = {
    xs: 0,
    sm: 375,
    md: 768,
    lg: 1024,
    xl: 1366,
    xxl: 1650,
};
